import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from '@ocean/hooks'
import { controls } from '@ocean/ui'
import { StaRedirectParams } from 'core/staIntegration/types'
import { HighlightedNotificationsFactory } from 'modules/Notifications/components'
import { namespace } from 'modules/Notifications/localization'
import { NotificationItem } from 'modules/Notifications/types'
import {
  Wrapper,
  ContentScrollbars,
  Content,
  Footer,
  FooterSide,
  FooterLink,
  FooterAction,
} from './HighlightedNotifications.styled'

const { Button } = controls

const I18_PATH = `${namespace}:notifications.highlighted`

type HighlightedNotificationsProps = {
  notifications?: NotificationItem[]
  companyNoticeAlias?: string
  onMarkAsRead: (id: Guid) => void
  onRedirect: (redirectParams: StaRedirectParams) => void
  onClose: Callback
}

const HighlightedNotifications: React.FC<HighlightedNotificationsProps> = props => {
  const { t } = useTranslation()
  const isDesktop = useBreakpoint('sm')
  const { notifications, companyNoticeAlias, onMarkAsRead, onRedirect, onClose } = props

  // Mark popup as viewed on unmount
  useEffect(() => {
    return () => {
      onClose()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  function handleRedirectToAllNotifications() {
    onRedirect({ pluginName: 'TaskStatusPlugin', moduleName: null })
  }

  return (
    <Wrapper>
      <ContentScrollbars autoHeight={isDesktop} autoHeightMax={isDesktop ? '50vh' : undefined}>
        <Content>
          {notifications?.map(item => (
            <HighlightedNotificationsFactory
              key={item.id}
              item={item}
              companyNoticeAlias={companyNoticeAlias}
              onMarkAsRead={onMarkAsRead}
            />
          ))}
        </Content>
      </ContentScrollbars>
      <Footer>
        <FooterSide>
          <FooterLink
            onClick={handleRedirectToAllNotifications}
            data-test='HighlightedNotificationsFooterLink'
          >
            {t(`${I18_PATH}.viewAllNotifications`)}
          </FooterLink>
        </FooterSide>
        <FooterAction>
          <Button
            fill={!isDesktop}
            title={t(`${I18_PATH}.close`)}
            onClick={onClose}
            dataTest='HighlightedNotificationsCloseButton'
          />
        </FooterAction>
      </Footer>
    </Wrapper>
  )
}

export default HighlightedNotifications
